<template>
  <div id="banner">
    <el-row
      class="banner-container"
      :style="{ height: bannerHeight, backgroundColor: bannerBackGroundColor }"
    >
      <div v-if="showLoading" class="container">
        <img
          :src="require('@/assets/images/loadingImg.png')"
          alt=""
          class="loading-img"
        >
      </div>
      <el-col>
        <el-carousel
          v-if="showBanner"
          ref="lunboContainer"
          :interval="4000"
          arrow="never"
          :height="bannerHeight"
          mode="horizontal"
          :indicator-position="lunboData.length > 1 ? '' : 'none'"
        >
          <el-carousel-item v-for="(item, index) in lunboData" :key="index">
            <el-image
              ref="bannerHeight"
              :src="item.url"
              ondragstart="return false"
              style="width: 100%"
              @load="imgLoad"
              @mousedown.stop="imgMouseDownFun($event)"
              @mouseup.stop="imgMouseUpFun($event)"
              @touchstart.stop="imgMouseDownFun($event)"
              @touchend.stop="imgMouseUpFun($event)"
            />
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import API from '@/api/service'

export default {
  name: 'Banner',
  props: {
    bannerCatId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      innerWidthType: 'xs',
      lunboData: [],
      bannerHeight: '500px',
      tempBannerHeight: '',
      bannerBackGroundColor: '#f2eada',
      startX: '',
      endX: '',
      showBanner: false,
      showLoading: true
    }
  },
  watch: {
    bannerHeight(newVal, oldVal) {
      if (oldVal === this.tempBannerHeight) {
        this.showLoading = false
        this.bannerBackGroundColor = 'transparent'
      }
    }
  },
  created() {
    if (document.documentElement) {
      this.bannerHeight = `${document.documentElement.clientWidth * 0.3}px`
      this.tempBannerHeight = `${document.documentElement.clientWidth * 0.3}px`
    } else {
      this.bannerHeight = `${document.body.clientWidth * 0.3}px`
      this.tempBannerHeight = `${document.body.clientWidth * 0.3}px`
    }
  },
  mounted() {
    this.getLunboData()
    this.getInnerWidthType()
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
      this.imgLoad()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
      this.imgLoad()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth >= 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    getLunboData() {
      if (this.bannerCatId === 1) {
        this.lunboData = [
          {
            url: require('@/assets/images/banner.jpg')
          },
          {
            url: require('@/assets/images/banner2.jpg')
          }
        ]
        setTimeout(() => {
          this.$parent.setHeight()
        }, 548)
        this.showBanner = true
      } else {
        API.getBannerList({ banner_cat_id: this.bannerCatId })
          .then(res => {
            this.lunboData = res.data.reverse()
            this.lunboData.map(item => {
              if (window.innerWidth > 768) {
                item.remark = item.remark.replace(/\n/g, '<br>')
              }
            })
          })
          .finally(() => {
            setTimeout(() => {
              this.$parent.setHeight()
            }, 548)
            this.showBanner = true
          })
      }
    },
    imgLoad() {
      if (this.$refs.bannerHeight) {
        if (!this.$refs.bannerHeight.length) {
          return false
        }
        this.bannerHeight = `${this.$refs.bannerHeight[0].$el.clientHeight}px`
      }
    },
    imgMouseDownFun(event) {
      if (event.clientX === 0) return false
      this.startX = event.clientX ? event.clientX : event.touches[0].clientX
    },
    imgMouseUpFun(event) {
      if (event.clientX === 0) return false
      this.endX = event.clientX
        ? event.clientX
        : event.changedTouches[0].clientX
      if (Math.abs(this.endX - this.startX) > 100) {
        if (this.endX - this.startX > 0) {
          this.$refs.lunboContainer.prev()
        } else {
          this.$refs.lunboContainer.next()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#banner {
  .banner-container {
    $easing: cubic-bezier(0.55, 0.08, 0.36, 1.43);

    .container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 20vmin;
      height: 20vmin;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      // filter: url('#goo');
      opacity: 0.8;

      .loading-img {
        display: block;
        width: 9vmin;
        height: 9vmin;
        animation: rotate-move 8s $easing infinite;
      }

      @keyframes rotate-move {
        0% {
          transform: rotate(0deg);
        }
        25% {
          transform: rotate(360deg);
        }
        50% {
          transform: rotate(0deg);
        }
        75% {
          transform: rotate(360deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
    }
    /deep/ .el-carousel__indicators {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue